import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

class ModalFormFleet extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    if (props.fleet) { this.state.fleet = { ...props.fleet }; }
    if (props.key) { this.state.key = { ...props.key }; }

    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalAccept = this.handleModalAccept.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleKeyChange = this.handleKeyChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal && !this.props.showModal) {
      this.setState({
        key: nextProps.key || (nextProps.fleet && nextProps.fleet.$key) || '',
        fleet: {
          ...nextProps.fleet,
        },
      });
    }
  }

  getActionName() {
    return (this.props.fleet && this.props.fleet.name)
      ? 'edit'
      : 'create';
  }

  handleModalClose() {
    this.props.onCancel(this.state.fleet);
  }

  handleModalAccept(ev) {
    ev.preventDefault();

    this.props.onAccept(this.state.fleet, this.state.key);
    this.setState({ key: '', fleet: {} });
  }

  handleInputChange(ev) {
    const { name, value } = ev.target;

    this.setState({
      fleet: {
        [name]: value,
      },
    });
  }

  handleNameChange(ev) {
    const { value } = ev.target;

    const newState = {
      fleet: {
        name: value,
      },
    };

    if (this.getActionName() === 'create') { newState.key = _.kebabCase(_.lowerCase(value)); }

    this.setState(newState);
  }

  handleKeyChange(ev) {
    const { value } = ev.target;

    this.setState({
      key: _.kebabCase(_.lowerCase(value)),
    });
  }

  render() {
    return (
      <Modal show={this.props.showModal} onHide={this.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{this.getActionName() === 'create' ? 'Criando' : 'Editando'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Frota e Grupo</h3>

          <form onSubmit={this.handleModalAccept}>
            <div className="form-group">
              <label htmlFor="name">Nome</label>
              <input
                type="text"
                className="form-control"
                name="name"
                aria-describedby="fleetNameHelp"
                value={this.state.fleet.name}
                onChange={this.handleNameChange}
              />
              <small id="fleetNameHelp" className="form-text text-muted">Dê um nome para a operação que deseja cadastrar.</small>
            </div>

            <div className="form-group">
              <label htmlFor="key">Identificador</label>
              <input
                type="text"
                className="form-control"
                name="key"
                aria-describedby="fleetKeyHelp"
                value={this.state.key}
                onChange={this.handleKeyChange}
                disabled={this.getActionName() === 'edit'}
              />
              <small id="fleetKeyHelp" className="form-text text-muted">Identificador único da Operação. ATENÇÃO: Não poderá ser alterado!</small>
            </div>

            <button type="submit" hidden />
          </form>

        </Modal.Body>
        <Modal.Footer>
          <a
            className="button"
            onClick={this.handleModalClose}
            onKeyPress={this.handleModalClose}
            role="button"
            tabIndex={0}
          >
            Cancelar
          </a>
          <a
            className="button"
            onClick={this.handleModalAccept}
            onKeyPress={this.handleModalAccept}
            role="button"
            tabIndex={0}
          >
            Confirmar
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalFormFleet.propTypes = {
  key: PropTypes.string,
  fleet: PropTypes.shape({
    $key: PropTypes.string,
    name: PropTypes.string,
  }),
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};

ModalFormFleet.defaultProps = {
  key: '',
  fleet: {
    name: '',
  },
};

export default ModalFormFleet;



// WEBPACK FOOTER //
// ./src/Fleet/ModalFormFleet.js